module.exports = __webpack_public_path__ + "static/img/logo14.779f6f40.png";